import { EventField, SendEvent, UI_EVENT_TYPE } from './types';
import { SendEventModule } from './SendEventModule';
import { Analytics } from '@swiggy-private/swiggylytics';
import { sendCustomNREvViaBlaze } from 'utils/newRelic';

class AnalyticsClient extends SendEventModule {
  private initialized = false;

  init() {
    if (this.initialized) {
      return;
    }

    const endpoint = process.env.NEXT_PUBLIC_ANALYTICS_URL ?? "";
    if (!endpoint) {
      console.warn('Analytics endpoint not configured');
      return;
    }

    try {
      Analytics.init({
        endpoint,
      });
      this.initialized = true;
    } catch (error) {
      console.error('Error initializing analytics', error);
    }
  }

  destroy() {
    if (!this.initialized) {
      return;
    }

    try {
      Analytics.destroy();
      this.initialized = false;
    } catch (error) {
      console.error('Error destroying analytics', error);
    }
  }

  logImpression(event: SendEvent) {
    this.logDpEvent(UI_EVENT_TYPE.IMPRESSION, event);
  }

  logClick(event: SendEvent) {
    this.logDpEvent(UI_EVENT_TYPE.CLICK, event);
  }

  logScreenView(event: SendEvent) {
    this.logDpEvent(UI_EVENT_TYPE.SCREENVIEW, event);
  }

  private logDpEvent(type: UI_EVENT_TYPE, event: SendEvent) {
    try {
      this.customEvent({
        ...event,
        [EventField.ET]: type,
      });
    } catch (error) {
      console.error('Error logging dp event', error);
    }
  }

  logNewrelicEvent(type: string, name: string, fields: Record<string, string | number>) {
    try {
      sendCustomNREvViaBlaze(type, { name, ...fields }, undefined);
    } catch (error) {
      console.error('Error logging newrelic event', error);
    }
  }
}

export const analyticsClient = new AnalyticsClient();

